<div class="nav-item dropdown" ngbDropdown *ngIf="enabledOptions && enabledOptions.length > 0">
  <li class="nav-item">
    <button class="btn btn-primary" ngbDropdownToggle
            id="staffDropdown">Student
    </button>
  </li>
  <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="staffDropdown">
    <ng-container *ngFor="let option of enabledOptions">
      <button class="dropdown-item" [ngClass]="{active: (selectedOption === option.path)}" (click)="selectOption(option.path)">
        {{ option.name }}
      </button>
    </ng-container>
  </div>
</div>
